// Where an officer's account stands on the Officers page, and what an admin
// may still do about it. Someone who deleted their own account stays on the
// list, marked; they cannot be made an admin, but they can be disabled,
// which ends the account for good (decided 1 Oct 2026). The server applies
// the same rules (common/officer-roles.ts, disableOfficer).

export function officerAccountStatus(officer) {
  const status = officer?.user?.status;
  if (status === "DELETED") return "DELETED";
  if (status === "SUSPENDED") return "DISABLED";
  if (status === "PENDING_VERIFICATION") return "PENDING";
  return "ACTIVE";
}

/** Active or invited: counted as active, and may be made an admin. */
export function officerIsActive(officer) {
  const status = officerAccountStatus(officer);
  return status !== "DISABLED" && status !== "DELETED";
}

/** Anyone not already disabled, including someone who deleted their account. */
export function officerCanBeDisabled(officer) {
  return officerAccountStatus(officer) !== "DISABLED";
}
